var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGdns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    opacity: 0.3,
    d: "M5.25,2H16.083a1.25,1.25,0,0,1,1.25,1.25v2.5A1.25,1.25,0,0,1,16.083,7H5.25A1.25,1.25,0,0,1,4,5.75V3.25A1.25,1.25,0,0,1,5.25,2ZM9.833,3.667a.833.833,0,0,0,0,1.667H11.5a.833.833,0,0,0,0-1.667Z",
    transform: "translate(-0.667 -0.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    d: "M5.25,9H16.083a1.25,1.25,0,0,1,1.25,1.25v2.5A1.25,1.25,0,0,1,16.083,14H5.25A1.25,1.25,0,0,1,4,12.75v-2.5A1.25,1.25,0,0,1,5.25,9Zm4.583,1.667a.833.833,0,0,0,0,1.667H11.5a.833.833,0,0,0,0-1.667ZM5.25,14.833H16.083a1.25,1.25,0,0,1,1.25,1.25v2.5a1.25,1.25,0,0,1-1.25,1.25H5.25A1.25,1.25,0,0,1,4,18.583v-2.5A1.25,1.25,0,0,1,5.25,14.833ZM9.833,16.5a.833.833,0,1,0,0,1.667H11.5a.833.833,0,1,0,0-1.667Z",
    transform: "translate(-0.667 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdns);
export default __webpack_public_path__ + "static/media/gdns.937a731aa3fd0c58f6775c91d55ed3dc.svg";
export { ForwardRef as ReactComponent };